(() => {
  if (!document.body || !document.body.classList.contains('collection-template')) return;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const polishFacets = () => {
    document.querySelectorAll('#FacetFiltersContainer .facet-accordion-details, #MobileFacetFiltersContainer .facet-accordion-details').forEach((details) => {
      const heading = details.querySelector('.accordion-details__summary .h4');
      const label = normalize(heading?.textContent);
      if (label === 'product type' && !details.hidden) {
        details.hidden = true;
        details.setAttribute('aria-hidden', 'true');
        details.dataset.ksHiddenFilter = 'true';
      }
    });

    const mobileContainer = document.querySelector('#MobileFacetFiltersContainer form[is="facet-form"]');
    if (mobileContainer) {
      const colorFacet = Array.from(mobileContainer.querySelectorAll('.facet-accordion-details')).find((details) => {
        const heading = details.querySelector('.accordion-details__summary .h4');
        const label = normalize(heading?.textContent);
        return label === 'color' || label === 'colour' || label === 'colors' || label === 'colours';
      });
      if (colorFacet) {
        const firstVisibleFacet = Array.from(mobileContainer.children).find((node) =>
          node.classList?.contains('facet-accordion-details') && !node.hidden
        );
        if (firstVisibleFacet && firstVisibleFacet !== colorFacet) {
          mobileContainer.insertBefore(colorFacet, firstVisibleFacet);
        }
        colorFacet.open = true;
      }
    }
  };

  const handleSortChange = (event) => {
    const select = event.target.closest('select[name="sort_by"]');
    if (!select || !document.body.classList.contains('collection-template')) return;

    event.stopImmediatePropagation();
    const url = new URL(window.location.href);
    if (select.value) url.searchParams.set('sort_by', select.value);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    window.location.assign(url.toString());
  };

  document.addEventListener('change', handleSortChange, true);

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      polishFacets();
    });
  };

  schedule();
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('collection:rerendered', schedule);

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
})();
